<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<!-- 첫번째 ROW -->
						<tr>
							<!-- 검사번호 -->
							<th class="col-1">{{ getMessage_('QWCC000005') }}</th>
							<td class="col-1"><el-input v-model="formInfo.ckuNo" readOnly /></td>
							<!-- 변경번호 -->
							<th class="col-1">{{ getMessage_('QWCC000006') }}</th>
							<td class="col-1"><el-input :value="formInfo.altrNo" readOnly /></td>
							<!-- 유형 -->
							<th class="col-1">* {{ getMessage_('QWCC000069') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="formInfo.partClCd"
									:options="getPartClCdList_"
									:onChange="value => onDataInit({ key: 'partClCd', value })"
									:disabled="chkStateDisabled"
								/>
							</td>
							<!-- 종합판정 -->
							<th class="col-1">{{ getMessage_('QWCC000008') }}</th>
							<td :class="formInfo.ovrlJgmtCd === 'NG' ? 'col-1 rsltNg' : 'col-1'">
								<sf-select-group
									labelPosition="left"
									:inputValue="formInfo.ovrlJgmtCd"
									:options="getOvrlJgmtCdList_"
									:onChange="value => onChangeJgmtCd({ key: 'ovrlJgmtCd', value })"
									:disabled="chkGrp"
								/>
							</td>
							<!-- 검사분류 -->
							<th class="col-1">* {{ getMessage_('QWCC000007') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="formInfo.ckuClCd"
									:options="getCkuClCdList_"
									:onChange="value => onChangeParam({ key: 'ckuClCd', value })"
									:disabled="chkStateDisabled"
								/>
							</td>
						</tr>

						<!-- 두번째 ROW -->
						<tr>
							<!-- 검사원 -->
							<th>{{ getMessage_('QWCC000009') }}</th>
							<td class="col-1"><el-input :value="formInfo.ckurNm" readOnly /></td>
							<!-- 검토자 -->
							<th>{{ getMessage_('QWCC001092') }}</th>
							<td><el-input :value="formInfo.affrDspoNm1" readOnly /></td>
							<!-- 검토일 -->
							<th>{{ getMessage_('QWCC001384') }}</th>
							<td>
								<el-input :value="formInfo.affrPrcsDt1" readOnly />
							</td>
							<!-- 승인자 -->
							<th>{{ getMessage_('QWCC000011') }}</th>
							<td>
								<el-input :value="formInfo.affrDspoNm2" readOnly />
							</td>
							<!-- 승인일 -->
							<th>{{ getMessage_('QWCC000012') }}</th>
							<td><el-input :value="formInfo.affrPrcsDt2" readOnly /></td>
						</tr>

						<!-- 세번째 ROW -->
						<tr>
							<!-- 품번 -->
							<th>{{ getMessage_('QWCC000956') }}</th>
							<td class="col-1"><el-input :value="formInfo.partNo" readOnly /></td>
							<!-- 협력사 -->
							<th>{{ getMessage_('QWCC000958') }}</th>
							<td>
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input v-model="formInfo.cofNm" class="inputWithIcon" maxlength="40"></el-input>
											<i class="icon-sf-search search-icon" @click="onCofPopup"></i>
										</div>
									</el-col>
								</div>
								<!-- <el-input :value="formInfo.cofCd" readOnly /> -->
							</td>
							<!-- 검사일자 -->
							<th>{{ getMessage_('QWCC000070') }}<i class="icon-sf-caret-bottom" /></th>
							<!-- 시작시간 -->
							<th>{{ getMessage_('QWCC000071') }}<i class="icon-sf-caret-bottom" /></th>
							<!-- 종료시간 -->
							<th>{{ getMessage_('QWCC000072') }}<i class="icon-sf-caret-bottom" /></th>
							<!-- 검사수량 -->
							<th>
								* {{ getMessage_('QWCC000073') }}<i class="icon-sf-caret-bottom" />
								<!-- 적용 -->
								<sf-button line icon="" size="sm" :onClick="() => onDataInit({ key: 'ckuScnCd', value: 'L' })">
									{{ getMessage_('QWCC001933') }}</sf-button
								>
							</th>
							<!-- 불량수량 -->
							<th>* {{ getMessage_('QWCC000074') }}<i class="icon-sf-caret-bottom" /></th>
							<!-- 리페어OK -->
							<th>{{ getMessage_('QWCC000075') }}<i class="icon-sf-caret-bottom" /></th>
						</tr>

						<!-- 네번째 ROW -->
						<tr>
							<!-- 품명 -->
							<th>{{ getMessage_('QWCC000957') }}</th>
							<td><el-input :value="formInfo.partNm" readOnly /></td>
							<!-- 검사구분(LOT : x1~x10 까지 입력가능, Serial : x1만 입력가능) -->
							<th>* {{ getMessage_('QWCC002081') }}</th>
							<td>
								<!-- <sf-select-group
									labelPosition="left"
									:inputValue="formInfo.ckuScnCd"
									:options="getCkuScnCdList_"
									:onChange="value => onDataInit({ key: 'ckuScnCd', value })"
									:disabled="chkStateDisabled"
								/> -->
								<el-input
									id="orderNo"
									inputType="input"
									v-model="formInfo.orderNo"
									:onChange="value => onChangeParam({ key: 'orderNo', value })"
									maxlength="18"
									show-word-limit
								/>
							</td>
							<!-- 검사일자 -->
							<td><el-input :value="formInfo.ckuDd" readOnly /></td>
							<!-- 시작시간 -->
							<td><el-input :value="formInfo.ckuStrtDt" readOnly /></td>
							<!-- 종료시간 -->
							<td><el-input :value="formInfo.ckuEndDt" readOnly /></td>
							<!-- 검사수량 -->
							<td class="col-1">
								<el-input
									inputType="input"
									v-model="formInfo.ckuQty"
									@input="value => input(value, 'ckuQty')"
									maxlength="7"
									show-word-limit
									:disabled="chkStateDisabled"
								/>
							</td>
							<!-- 불량수량 -->
							<td class="col-1">
								<el-input
									inputType="number"
									v-model="formInfo.badQty"
									@input="value => input(value, 'badQty')"
									maxlength="7"
									show-word-limit
									:disabled="chkStateDisabled"
								/>
							</td>
							<!-- 리페어OK -->
							<td><el-input :value="formInfo.rprYn" readOnly /></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- 팝업 -->
		<comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId"></comp-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCku/store/helpers';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';

export default {
	data() {
		return {
			data: '',
			date1: '',
			input1: '',
			pprNo: '',
			time1: new Date()
		};
	},
	props: {
		scrId: { type: String, default: '' },
		flgOsGrp: { type: Boolean, default: false },
		flgPqyapGrp: { type: Boolean, default: false },
		flgPqyrvGrp: { type: Boolean, default: false },
		flgPqyrgGrp: { type: Boolean, default: false }
	},
	components: { CompPopup },
	async created() {
		// await this.getCommCodes_({ key: 'passDsqfList', codeType: 'INDV_JGMT' }); //합불기준코드;
		// await this.getCommCodes_({ key: 'partClList', codeType: 'PART_CL' }); //유형;
		// await this.getCommCodes_({ key: 'ovrlJgmtList', codeType: 'OVRL_JGMT' }); //종합판정;
		// await this.getCommCodes_({ key: 'ckuScnList', codeType: 'CKU_SCN' }); //검사구분;
		// await this.getCommCodes_({ key: 'ckuPrvsList', codeType: 'CKU_PRVS' }); //대분류(검사항목);
		// await this.getCommCodes_({ key: 'ckuClList', codeType: 'CKU_CL' }); //소분류(검사분류);
		// await this.getCommCodes_({ key: 'ckuWayList', codeType: 'CKU_WAY' }); //검사방법;
		// await this.getCommCodes_({ key: 'jgmtCrtnList', codeType: 'JGMT_CRTN' }); //판정기준;
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chkStateDisabled() {
			// 현재 승인로직 상태가 검토(40) 또는 승인(50) 일경우 체크
			if (this.formInfo.pgsStCd === '40' || this.formInfo.pgsStCd === '50') {
				return true;
			} else {
				return false;
			}
		},
		chkGrp() {
			let pass = true;
			if (this.flgOsGrp || this.flgPqyapGrp || this.flgPqyrvGrp) {
				pass = false;
			}
			return pass;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChangeParam(payload) {
			this.$sf_toggleLoading(true);
			this.onChangeParam_(payload)
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		onDataInit(payload) {
			const { key, value } = payload;
			const pgsStCd = this.formInfo.pgsStCd;
			if (pgsStCd === '20' || pgsStCd === '40' || pgsStCd === '50') {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC002062') }); //검사완료 이상의 상태에서는 적용이 불가능 합니다.
				return false;
			}
			if (key === 'ckuScnCd') {
				// 검사구분 항목을 변경시 시리얼 일때
				if (value === 'S') {
					this.onChangeParam({ key: 'ckuQty', value: 1 });
					for (let i = 0; i < this.resultList.length; i++) {
						if (this.resultList[i].comboYn === 'Y') {
							this.resultList[i].x1 = 'OK';
						}
						this.resultList[i].x2 = null;
						this.resultList[i].x3 = null;
						this.resultList[i].x4 = null;
						this.resultList[i].x5 = null;
						this.resultList[i].x6 = null;
						this.resultList[i].x7 = null;
						this.resultList[i].x8 = null;
						this.resultList[i].x9 = null;
						this.resultList[i].x10 = null;
					}
				} else if (value === 'L') {
					//lot 일때
					let cnt = this.formInfo.ckuQty;
					if (cnt > 10) {
						cnt = 10;
					}
					for (let i = 0; i < this.resultList.length; i++) {
						if (this.resultList[i].comboYn === 'Y') {
							for (let cnt2 = 1; cnt2 <= cnt; cnt2++) {
								let colNm = `x${cnt2}`;
								if (cnt2 <= cnt) {
									this.resultList[i][colNm] = 'OK';
								} else {
									this.resultList[i][colNm] = null;
								}
							}
						}
					}
				}
			} else if (key === 'partClCd') {
				// 유형 항목을 변경시 양산일때
				if (value === 'MP' || value === 'AS') {
					for (let i = 0; i < this.resultList.length; i++) {
						this.resultList[i].avgVal = null; // 평균
						this.resultList[i].stdDvatVal = null; // 표준편차
						this.resultList[i].powAbltVal = null; // 공정능력
					}
				}
			}

			this.onChangeParam(payload);
		},
		//종합판정 변경
		onChangeJgmtCd(payload) {
			const cnt = this.resultList.length;
			try {
				if (cnt > 0) {
					let rstCnt = 0;
					for (let i = 0; i < cnt; i++) {
						if (this.resultList[i].jgmtNm !== null && this.resultList[i].jgmtNm !== '') {
							rstCnt++;
						}
					}

					//Row의 수와 Row의 결과 값의 수가 같으면 종합판정을 DB에 바로 저장가능하다.
					if (cnt === rstCnt) {
						const params = {
							partNo: this.formInfo.partNo,
							ckuNo: this.formInfo.ckuNo,
							ovrlJgmtCd: payload.value
						};

						// 컨펌창 실행
						this.$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							title: this.getMessage_('QWCC001428'), //종합판정 결과를 변경하시겠습니까?
							buttons: [{ title: this.getMessage_('QWCC001131'), clickFn: () => this.updOvrlJgmdCd(payload, params) }] //저장
						});
					} else {
						this.onChangeParam(payload);
					}
				} else {
					this.onChangeParam(payload);
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		//종합판정결과 변경(승인,작성 권한만 가능)
		async updOvrlJgmdCd(payload, params) {
			this.$sf_toggleLoading(true);
			try {
				this.onChangeParam(payload);
				const { code, messageCd } = await this.saveChangeJgmtCd_(params);
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
				this.$sf_toggleLoading(false);
			} catch (error) {
				this.$sf_toggleLoading(false);
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		jgmtDisabled() {
			// const { type } = this.popupParams;
			// return type.includes('update');
			return true;
		},
		//input 숫자만 입력가능
		input(value, target) {
			let numberRegEx = /[^0-9]/g; //숫자만 입력가능
			let val = value.replace(numberRegEx, '');
			this.onChangeParam_({ key: target, value: val });
		},
		onCofPopup() {
			// this.$refs.partMngPopup.open(this.searchParams.cofCd);
			let params = {
				cpnyScn: '10',
				cpnyCd: this.formInfo.cofNm
			};
			this.$refs.compPopup.open(params);
		},
		qpyCpnyData({ cpnyCd, cpnyNm }) {
			this.onChangeParam_({ key: 'cofCd', value: cpnyCd });
			this.onChangeParam_({ key: 'cofNm', value: cpnyNm });
		}
	}
};
</script>

<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -1px;
}
</style>
